import {cn} from '@/lib/utils'

/**
 * Avisa sin contar (UX O2): nunca un número. `label` es obligatorio (U17) y dice lo que el punto
 * agrega, no una copia del texto de al lado.
 */
export function AmberDot({label, className, testId}: {label: string; className?: string; testId?: string}) {
  return (
    <span data-testid={testId} className={cn('h-2 w-2 shrink-0 rounded-full bg-tone-amber-fg', className)}>
      <span className="sr-only">{label}</span>
    </span>
  )
}
